@if (popConfirmVisible()) {
  <div>
    <vti-pop-confirm [title]="popconfirmTitle" [visible]="popConfirmVisible()" (okClick)="popConfirmOkClick()" (cancelClick)="popConfirmCancelClick()"></vti-pop-confirm>
  </div>
}
<button [type]="type" class="inline-flex items-center text-sm font-semibold" [disabled]="loading || disabled" [ngClass]="classes()" (click)="buttonClick()">
  @if (loading) {
    <vti-icons class="mr-2 mb-1 inline" [icon]="'loading'"></vti-icons>
  }
  @if (!loading && icon) {
    <vti-icons class="mr-2 mb-1" [icon]="icon" [size]="icon === 'cancel' ? 5 : 4" [color]="ghost ? 'vti' : 'white'"></vti-icons>
  }
  {{ text }}
</button>
